import {useContext, useState} from "react";
import QRCodeContext from "../../../../../contexts/qr-code/QRCodeContext";
import {Button, FileInput, Stack, TextInput} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import PdfAttachmentApi from "../../../../../api/pdf-attachment/PdfAttachmentApi";

function PdfInputData() {
    /**
     * QRCodeContext
     * @author Kacper Faber
     * @since 0.2.0
     */
    const qrCodeContext = useContext(QRCodeContext);

    /**
     * Navigate function from react-router-dom
     * @author Kacper Faber
     * @since 0.2.0
     */
    const nav = useNavigate();

    /**
     * State represents QRCode's name to be sent
     * @author Kacper Faber
     * @since 0.2.0
     */
    const [name, setName] = useState<string>('');

    const [file, setFile] = useState<File | null>(null);

    /**
     * On create button is clicked
     * @author Kacper Faber
     * @since 0.2.0
     */
    const onCreateClicked = () => {
        if (!file) {
            return;
        }

        PdfAttachmentApi.create({file})
            .then(({id}) => qrCodeContext.create({name, kind: 'pdf', pdfAttachment: id}))
            .then(() => nav('/'));
    }

    return (
        <Stack>
            <TextInput
                onChange={e => setName(e.target.value)}
                placeholder="Nazwa kodu QR"
            />

            <FileInput
                placeholder="Plik PDF"
                onChange={setFile}
                accept="application/pdf"
            />

            <Button
                onClick={onCreateClicked}
                children="Zapisz"
            />
        </Stack>
    );
}

export default PdfInputData;